import {
    EditOutlined,
    FullscreenExitOutlined,
    FullscreenOutlined,
    FundOutlined,
    HomeOutlined,
    MailOutlined,
    UpSquareOutlined,
    UsergroupDeleteOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { setTabList } from "../../store/reducers/tab";
const { Sider } = Layout;


const items = [
    {
        key: '/home',
        icon: <HomeOutlined />,
        label: '主页'
    },
    {
        key: '/oauthConfig',
        icon: <EditOutlined />,
        label: '权限配置'
    },
    {
        key: '/emailConfig',
        icon: <MailOutlined />,
        label: '邮箱配置'
    },
    {
        key: '/userInfo',
        icon: <UsergroupDeleteOutlined />,
        label: '用户列表'
    },
    {
        key: '/donation',
        icon: <FullscreenOutlined />,
        label: '捐助列表'
    },
    {
        key: '/assistance',
        icon: <FullscreenExitOutlined />,
        label: '受助列表'
    },
    {
        key: '/upgrade',
        icon: <UpSquareOutlined />,
        label: '升档列表'
    },
    {
        key: '/matchResult',
        icon: <FundOutlined />,
        label: '匹配列表'
    },
]

const CommonAside = () => {
    //获取展开收起的状态
    const collapsed = useSelector((state: any) => state.tab.isCollapse)
    const navigate = useNavigate()
    const dispath = useDispatch()
    const location = useLocation()
    const selectedKey = location.pathname;

    // dispath(setTabList(val))
    const selectMenu = (e: any) => {
        // let data
        // MenuConfig.forEach(item=>{
        //     if(item.path === e.keyPath[e.keyPath.length-1]){
        //         data = item
        //         if(e.keyPath.length>1){
        //             data = item.children.find(child=>{return child.path == e.key})
        //         }
        //     }
        // })
        // dispath(setTabList({path:data.path,name:data.name,label:data.label}))
        navigate(e.key)
    }
    return (
        <Sider trigger={null} collapsed={collapsed}>
            <h3 className="app-name">{collapsed ? '馨园' : '馨园后台管理'}</h3>
            <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['/home']}
                selectedKeys={[selectedKey]}
                items={items}
                onClick={selectMenu}
                style={{
                    height: '100%'
                }} />
        </Sider>
    );
}

export default CommonAside